import { cn } from '@/lib/utils'

import type { SketchToneSkin } from './tones'

type SketchFillProps = {
  skin: SketchToneSkin
  className?: string
}

function sketchTextureStyle(texture: SketchToneSkin['texture']) {
  const image = { backgroundImage: `url("${texture.src}")` }
  if (!texture.width || !texture.height) {
    return image
  }

  const ratio = texture.pixelRatio ?? 1
  return {
    ...image,
    backgroundSize: `${texture.width / ratio}px ${texture.height / ratio}px`,
  }
}

// Plain rounded rect under the border. Inset by 1px (Figma padding) so the border always covers
// its edge; radius follows the corner cell so it stays aligned when --sketch-cap changes.
export function SketchFill({ skin, className }: SketchFillProps) {
  const texture = skin.texture
  const tiled = Boolean(texture.width && texture.height)

  return (
    <span
      aria-hidden
      className={cn(
        'pointer-events-none absolute inset-px overflow-hidden rounded-(--sketch-fill-radius)',
        skin.fill,
        className,
      )}
    >
      <span
        className={cn(
          'absolute inset-0 bg-center mix-blend-luminosity',
          tiled ? 'bg-repeat' : 'bg-cover',
          texture.opacityClass,
        )}
        style={sketchTextureStyle(texture)}
      />
    </span>
  )
}
